import { render, staticRenderFns } from "./ChatDistributions.vue?vue&type=template&id=450f248e&scoped=true"
import script from "./ChatDistributions.vue?vue&type=script&lang=js"
export * from "./ChatDistributions.vue?vue&type=script&lang=js"
import style0 from "./ChatDistributions.vue?vue&type=style&index=0&id=450f248e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f248e",
  null
  
)

export default component.exports